import { Component, inject } from '@angular/core';
import { SponsorsStateService } from './shared/components/sponsors/services/sponsors-state.service';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent {
  protected sponsorsStateService = inject(SponsorsStateService);
}
